<script>
import Carregando from '~componentes/Carregando.vue';
import pessoaFisicaServico from '../servico';


export default {
  components: {
    Carregando
  },
  data() {
    return {
      carregando: true,
      assinaturas: [],
      assinaturasCanceladas: [],
      assinaturasDisponiveis: []
    }
  },
  mounted() {
    this.$root.tituloDaPagina = 'Assinatura Eletrônica';

    this.carregar();
  },
  methods: {
    carregar() {
      this.buscarAssinaturas()
      return;
    },
    buscarAssinaturas() {
      this.carregando = true;

      return pessoaFisicaServico
        .buscarAssinaturas()
        .then(dados => {
          this.assinaturas = dados;
          console.log("this.assinaturas => ", this.assinaturas)
        })
        .then(() => {
          this.carregando = false;
        });
    },
    filtrarAssinaturas() {
      this.assinaturasDisponiveis = this.assinaturas.filter((assinatura) => {
        return assinatura.dadosAssinante.statusAssinatura == "AGUARDANDO"
      })
      this.assinaturasCanceladas = this.assinaturas.filter((assinatura) => {
        return assinatura.dadosAssinante.statusAssinatura !== "AGUARDANDO"
      })
    },
    downloadArquivoAssinatura(documento, assinatura) {
      return pessoaFisicaServico.downloadArquivoAssinatura(assinatura.idDocumentoAssinaturaAssinante, documento.nomeArquivo).then(
        arquivo => { arquivo.download() }
      )
    },
    assinarDocumento(documento) {
        this.$router.push({
          name: 'pessoa-fisica.assinatura.assinar',
          params: { id: documento.idDocumentoAssinaturaAssinante },
        });
    },
  },
  watch: {
    assinaturas() {
      this.filtrarAssinaturas()
    }
  }
}
</script>

<template>
  <div>

    <form @submit.prevent="">

      <carregando v-if="carregando"></carregando>

      <div class="tabs-container" v-show="!carregando" id="tabs">

        <ul class="nav nav-tabs">
          <li class="active">
            <a data-toggle="tab" href="#tab-em-aberto">
              Em aberto
            </a>
          </li>
          <li>
            <a data-toggle="tab" href="#tab-finalizadas">
              Finalizadas
            </a>
          </li>
        </ul>

        <div class="tab-content">
          <div id="tab-em-aberto" class="tab-pane active">
            <div class="panel-body">
              <h1>Em aberto</h1>

              <div class="table-responsive" style="padding-top: 20px;" v-if="assinaturasDisponiveis.length > 0">
                <table class="table relatorio table-bordered">
                  <thead>
                    <tr>
                      <th>Nome do Arquivo</th>
                      <th>Tipo do Arquivo</th>
                      <th>Papel do Assinante</th>
                      <th>Data de Criação do Documento</th>
                      <th>Status da Assinatura</th>
                      <th class="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in assinaturasDisponiveis" :key="item.dadosAssinante.idDocumentoAssinaturaAssinante">
                      <td>{{ item.dadosDocumento.nomeArquivo }}</td>
                      <td>{{ item.dadosDocumento.tipoDocumento }}</td>
                      <td>{{ item.dadosAssinante.papelAssinatura }}</td>
                      <td>{{ item.dadosDocumento.dataHoraCriacao | formatarData }} - {{ item.dadosDocumento.dataHoraCriacao | formatarHora }}</td>
                      <td>{{ item.dadosAssinante.statusAssinatura }}</td>
                      <td class="text-center">
                      <button type="button" 
                              class="btn btn-success btn-xs"
                              v-tooltip="'Baixar arquivo'"
                              @click="downloadArquivoAssinatura(item.dadosDocumento, item.dadosAssinante)">
                        <i class="fa fa-download"></i>
                      </button>
                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Assinar documento'"
                              @click="assinarDocumento(item.dadosAssinante)">
                        <i class="fa fa-archive"></i>
                      </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>



            </div>
          </div>

          <div id="tab-finalizadas" class="tab-pane">
            <div class="panel-body">
              <h1>Finalizadas</h1>
              <h2>Em desenvolvimento</h2>
              <!-- <div class="table-responsive" style="padding-top: 20px;" v-if="assinaturasCanceladas.length > 0">
                <table class="table relatorio table-bordered">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Tipo</th>
                      <th>Papel</th>
                      <th>Status</th>
                      <th class="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in assinaturasCanceladas" :key="item.dadosAssinante.idDocumentoAssinaturaAssinante">
                      <td>{{ item.dadosDocumento.nomeArquivo }}</td>
                      <td>{{ item.dadosDocumento.tipoDocumento }}</td>
                      <td>{{ item.dadosAssinante.papelAssinatura }}</td>
                      <td>{{ item.dadosAssinante.statusAssinatura }}</td>
                      <td class="text-center">
                        <button @click="downloadArquivo(item.dadosDocumento)" class="btn btn-sm btn-primary">
                          <i class="fa bi-download"></i> Download
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
            </div>
          </div>
        </div>

      </div>
    </form>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pessoa-fisica/componentes/Assinatura.vue